<template>
    <footer class="footer">
        <a href="#top" title="Top" class="button_top" v-smooth-scroll="{ duration: 1000 }"><svg class="icon icon-cheveron-up"><use xlink:href="#icon-cheveron-up"></use></svg></a>
        <p class="credits">企画：<a href="http://www.bitters.co.jp/" target="_blank" title="ビターズ">ビターズ・エンド</a>
            <br>協力：<a href="https://neopa.jp/" target="_blank" title="NEOPA">NEOPA</a>、<a href="https://loadshow.jp/" target="_blank">LOAD SHOW</a>、<a href="http://fictive.jp/" target="_blank" title="fictive">fictive</a>、
            <br class="hide-for-medium">神戸ワークショップシネマプロジェクト、
            <br class="hide-for-medium"><a href="http://enbuzemi.co.jp/" target="_blank" title="ENBUゼミナール">ENBUゼミナール</a>、<a href="http://fm.geidai.ac.jp/" target="_blank" title="東京藝術大学大学院映像研究科">東京藝術大学大学院映像研究科</a>、
            <br class="hide-for-medium"><a href="http://silentvoice.or.jp/" target="_blank" title="サイレントヴォイス">サイレントヴォイス</a></p>
    </footer>
</template>

<script>
export default {
    name: 'hero',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue